<template>
  <el-dialog title="更新记录" :visible.sync="currentValue" width="60%" custom-class="updateDialog-class" append-to-body @open="init">
    <template #title>
      <div class="updateDialog-class-title">
        <span class="title-first" :class="{'show-reset': !show}" @click="goBack">更新记录</span>
        <span v-if="show" class="line">/</span>
        <span v-if="show">{{ openedName }}</span>
      </div>
    </template>
    <nothing v-if="!loading && tableData.length === 0"></nothing>
    <el-table
      :data="tableData"
      v-loading="loading"
      @row-click="rowClick"
      row-class-name="updateDialog-table"
      v-else-if="!show"
      style="width: 100%">
      <el-table-column
        show-overflow-tooltip
        prop="date"
        label="更新人">
        <template #default="scope">
          <span>{{scope.row.updated_user ? scope.row.updated_user.realname : '-'}}</span>
        </template>
      </el-table-column>
      <el-table-column
        show-overflow-tooltip
        prop="updated_reason"
        label="更新原因">
      </el-table-column>
      <el-table-column
        show-overflow-tooltip
        prop="name"
        label="说明文件">
        <template #default="scope">
           <UploadPopover v-if="scope.row.updated_reason_attachments && scope.row.updated_reason_attachments.length > 0" upload_type="product" v-model="scope.row.updated_reason_attachments" disabled table></UploadPopover>
           <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        show-overflow-tooltip
        prop="create_time"
        label="更新时间">
        <template #default="scope">
          <span>{{scope.row.create_time ? scope.row.create_time.replace(/-/g, '/') : '-'}}</span>
        </template>
      </el-table-column>
    </el-table>
    <template #footer v-if="!show">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pagData.page" :page-sizes="pagData.pageSizes" :page-size="pagData.number" :layout="pagData.layout" :total="pagData.total" hide-on-single-page>
      </el-pagination>
    </template>
    <UpdateMessage :id="openedId" :openedName="openedName" v-if="show"></UpdateMessage>
  </el-dialog>
</template>
<script>
import api from '@/services/api/product/product'
import UpdateMessage from './message';
import UploadPopover from '@/components/uploadInput'
export default {
  props: ['value', 'id'],
  components: {
    UpdateMessage,
    UploadPopover
  },
  data() {
    return {
      pagData: {
        // 分页参数
        page: 1, // 页码
        pageSizes: [30, 50, 100], // 每页条数类型
        number: 30, // 每页显示条数
        layout: "prev, pager, next, sizes", // 布局
        total: 0 // 总页数
      },
      tableData: [],
      page: 1,
      per_page: 30,
      loading: true,
      openedId: '',
      openedName: '',
      show: false,
      files: {}
    }
  },
  computed: {
    currentValue: {
      get: function () {
        return this.value || undefined;
      },
      set: function (newValue) {
        this.$emit('input', newValue || null)
      }
    },
  },
  methods: {
    handleSizeChange(val) {
      this.per_page = val
      this.page = 1
      this.init()
    },
    handleCurrentChange(val) {
      this.page = val
      this.init()
    },
    async init() {
      this.show = false
      this.loading = true
      let result = await api.productUpdateHistoriesIndex({ page: this.page, per_page: this.per_page, product_id: this.id })
      result.data.map(res => {
        res.updated_reason_attachments = res.updated_reason_attachments ? Object.entries(res.updated_reason_attachments).map(([key, value]) => value) : []
      })
      this.tableData = result.data
      console.log('----------',this.tableData )
      this.loading = false
    },
    rowClick(row) {
      console.log(row)
      this.openedId = row?.id
      this.openedName = row?.updated_user?.realname
      this.show = true
    },
    goBack() {
      this.show = false
    }
  },
}
</script>
<style lang="scss">
.updateDialog-class {
  .el-dialog__body {
    min-height: 300px;
    position: relative;
  }
  .updateDialog-table {
    cursor: pointer;
  }
  .el-dialog {
    border-radius: 8px;
  }
  .el-dialog__headerbtn {
    top: 15px;
  }
  .el-dialog__header {
    padding: 17px 24px;
    border-bottom: 1px solid #EEEEEE;
    .updateDialog-class-title {
      font-size: 18px;
      font-weight: 400;
      .line {
        margin-right: 6px;
        color: rgba(32, 32, 32, 0.60);
      }
      .title-first {
        color: rgba(32, 32, 32, 0.60);
        cursor: pointer;
        &:hover {
          color: initial;
        }
      }
      .show-reset {
        color: initial;
        cursor: initial;
        &:hover {
          color: initial;
        }
      }
    }
  }
}
</style>
